import { render } from "./EventAnnounce.vue?vue&type=template&id=1379f329&scoped=true"
import script from "./EventAnnounce.vue?vue&type=script&lang=js"
export * from "./EventAnnounce.vue?vue&type=script&lang=js"

import "./EventAnnounce.vue?vue&type=style&index=0&id=1379f329&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1379f329"]])

export default __exports__